import initialState from './initialState';
import {
  EXPORT_CONFIGURATIONS_ADMIN_GET_GROUPS_INIT,
  EXPORT_CONFIGURATIONS_ADMIN_GET_GROUPS_SUCCESS,
  EXPORT_CONFIGURATIONS_ADMIN_GET_GROUPS_FAILURE,
  EXPORT_CONFIGURATIONS_ADMIN_GET_CALCULATION_UNITS_INIT,
  EXPORT_CONFIGURATIONS_ADMIN_GET_CALCULATION_UNITS_SUCCESS,
  EXPORT_CONFIGURATIONS_ADMIN_GET_CALCULATION_UNITS_FAILURE,
  EXPORT_CONFIGURATIONS_ADMIN_GET_METRIC_GROUPS_LIST_INIT,
  EXPORT_CONFIGURATIONS_ADMIN_GET_METRIC_GROUPS_LIST_SUCCESS,
  EXPORT_CONFIGURATIONS_ADMIN_GET_METRIC_GROUPS_LIST_FAILURE,
  EXPORT_CONFIGURATIONS_ADMIN_GET_METRICS_LIST_INIT,
  EXPORT_CONFIGURATIONS_ADMIN_GET_METRICS_LIST_SUCCESS,
  EXPORT_CONFIGURATIONS_ADMIN_GET_METRICS_LIST_FAILURE,
  EXPORT_CONFIGURATIONS_ADMIN_GET_MODELS_LIST_INIT,
  EXPORT_CONFIGURATIONS_ADMIN_GET_MODELS_LIST_SUCCESS,
  EXPORT_CONFIGURATIONS_ADMIN_GET_MODELS_LIST_FAILURE,
  EXPORT_CONFIGURATIONS_ADMIN_GET_EXPORT_CONFIGURATIONS_LIST_INIT,
  EXPORT_CONFIGURATIONS_ADMIN_GET_EXPORT_CONFIGURATIONS_LIST_SUCCESS,
  EXPORT_CONFIGURATIONS_ADMIN_GET_EXPORT_CONFIGURATIONS_LIST_FAILURE,
  EXPORT_CONFIGURATIONS_ADMIN_SAVE_EXPORT_CONFIGURATION_INIT,
  EXPORT_CONFIGURATIONS_ADMIN_SAVE_EXPORT_CONFIGURATION_SUCCESS,
  EXPORT_CONFIGURATIONS_ADMIN_SAVE_EXPORT_CONFIGURATION_FAILURE,
  EXPORT_CONFIGURATIONS_ADMIN_DELETE_EXPORT_CONFIGURATION_PREPARE_INIT,
  EXPORT_CONFIGURATIONS_ADMIN_DELETE_EXPORT_CONFIGURATION_INIT,
  EXPORT_CONFIGURATIONS_ADMIN_DELETE_EXPORT_CONFIGURATION_SUCCESS,
  EXPORT_CONFIGURATIONS_ADMIN_DELETE_EXPORT_CONFIGURATION_FAILURE,
  EXPORT_CONFIGURATIONS_ADMIN_GET_BI_TEMPLATES_LIST_INIT,
  EXPORT_CONFIGURATIONS_ADMIN_GET_BI_TEMPLATES_LIST_SUCCESS,
  EXPORT_CONFIGURATIONS_ADMIN_GET_BI_TEMPLATES_LIST_FAILURE,
  EXPORT_CONFIGURATIONS_ADMIN_GET_POLYNOMIALS_LIST_INIT,
  EXPORT_CONFIGURATIONS_ADMIN_GET_POLYNOMIALS_LIST_SUCCESS,
  EXPORT_CONFIGURATIONS_ADMIN_GET_POLYNOMIALS_LIST_FAILURE,
  EXPORT_CONFIGURATIONS_ADMIN_GET_PERIODS_LIST_INIT,
  EXPORT_CONFIGURATIONS_ADMIN_GET_PERIODS_LIST_SUCCESS,
  EXPORT_CONFIGURATIONS_ADMIN_GET_PERIODS_LIST_FAILURE,
  EXPORT_CONFIGURATIONS_ADMIN_EXPORT_DATA_INIT,
  EXPORT_CONFIGURATIONS_ADMIN_EXPORT_DATA_SUCCESS,
  EXPORT_CONFIGURATIONS_ADMIN_EXPORT_DATA_FAILURE,
  EXPORT_CONFIGURATIONS_ADMIN_RESET,
} from '../../actions/exportConfigurationsAdmin/types';
import ReducersTooling from '../../../tooling/reducersTooling';

export default function exportConfigurationsAdmin(state = initialState, action) {
  switch (action.type) {
    case EXPORT_CONFIGURATIONS_ADMIN_GET_METRIC_GROUPS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "metricsGroupsList");
    case EXPORT_CONFIGURATIONS_ADMIN_GET_METRIC_GROUPS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "metricsGroupsList");
    case EXPORT_CONFIGURATIONS_ADMIN_GET_METRIC_GROUPS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "metricsGroupsList");

    case EXPORT_CONFIGURATIONS_ADMIN_GET_GROUPS_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "groupsFilteredList");
    case EXPORT_CONFIGURATIONS_ADMIN_GET_GROUPS_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "groupsFilteredList");
    case EXPORT_CONFIGURATIONS_ADMIN_GET_GROUPS_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "groupsFilteredList");

    case EXPORT_CONFIGURATIONS_ADMIN_GET_CALCULATION_UNITS_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "calculationUnitsFilteredList");
    case EXPORT_CONFIGURATIONS_ADMIN_GET_CALCULATION_UNITS_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "calculationUnitsFilteredList");
    case EXPORT_CONFIGURATIONS_ADMIN_GET_CALCULATION_UNITS_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "calculationUnitsFilteredList");

    case EXPORT_CONFIGURATIONS_ADMIN_GET_METRICS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "metricsList");
    case EXPORT_CONFIGURATIONS_ADMIN_GET_METRICS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "metricsList");
    case EXPORT_CONFIGURATIONS_ADMIN_GET_METRICS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "metricsList");

    case EXPORT_CONFIGURATIONS_ADMIN_GET_MODELS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "modelsList");
    case EXPORT_CONFIGURATIONS_ADMIN_GET_MODELS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "modelsList");
    case EXPORT_CONFIGURATIONS_ADMIN_GET_MODELS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "modelsList");

    case EXPORT_CONFIGURATIONS_ADMIN_GET_EXPORT_CONFIGURATIONS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "exportConfigurationsList");
    case EXPORT_CONFIGURATIONS_ADMIN_GET_EXPORT_CONFIGURATIONS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "exportConfigurationsList");
    case EXPORT_CONFIGURATIONS_ADMIN_GET_EXPORT_CONFIGURATIONS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "exportConfigurationsList");

    case EXPORT_CONFIGURATIONS_ADMIN_SAVE_EXPORT_CONFIGURATION_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitSave(initialState, state, action, "saveCurrentConfiguration");
    case EXPORT_CONFIGURATIONS_ADMIN_SAVE_EXPORT_CONFIGURATION_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessSave(initialState, state, action, "saveCurrentConfiguration");
    case EXPORT_CONFIGURATIONS_ADMIN_SAVE_EXPORT_CONFIGURATION_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureSave(initialState, state, action, "saveCurrentConfiguration");

    case EXPORT_CONFIGURATIONS_ADMIN_DELETE_EXPORT_CONFIGURATION_PREPARE_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStatePrepareDelete(initialState, state, action, "deleteConfiguration");
    case EXPORT_CONFIGURATIONS_ADMIN_DELETE_EXPORT_CONFIGURATION_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitDelete(initialState, state, action, "deleteConfiguration");
    case EXPORT_CONFIGURATIONS_ADMIN_DELETE_EXPORT_CONFIGURATION_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessDelete(initialState, state, action, "deleteConfiguration");
    case EXPORT_CONFIGURATIONS_ADMIN_DELETE_EXPORT_CONFIGURATION_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureDelete(initialState, state, action, "deleteConfiguration");

    case EXPORT_CONFIGURATIONS_ADMIN_GET_BI_TEMPLATES_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "biTemplatesList");
    case EXPORT_CONFIGURATIONS_ADMIN_GET_BI_TEMPLATES_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "biTemplatesList");
    case EXPORT_CONFIGURATIONS_ADMIN_GET_BI_TEMPLATES_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "biTemplatesList");

    case EXPORT_CONFIGURATIONS_ADMIN_GET_POLYNOMIALS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "polynomialsList");
    case EXPORT_CONFIGURATIONS_ADMIN_GET_POLYNOMIALS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "polynomialsList");
    case EXPORT_CONFIGURATIONS_ADMIN_GET_POLYNOMIALS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "polynomialsList");

    case EXPORT_CONFIGURATIONS_ADMIN_GET_PERIODS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "periodsList");
    case EXPORT_CONFIGURATIONS_ADMIN_GET_PERIODS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "periodsList");
    case EXPORT_CONFIGURATIONS_ADMIN_GET_PERIODS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "periodsList");

    case EXPORT_CONFIGURATIONS_ADMIN_EXPORT_DATA_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "exportData");
    case EXPORT_CONFIGURATIONS_ADMIN_EXPORT_DATA_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "exportData");
    case EXPORT_CONFIGURATIONS_ADMIN_EXPORT_DATA_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "exportData");
    
    case EXPORT_CONFIGURATIONS_ADMIN_RESET:
      return initialState;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./source/client/reducers/exportConfigurationsAdmin/index.js